import { RosterTableColumns } from "~pages/Roster/enums/rosterTableColumns.ts";
import { FixtureRosterTableColumns } from "~pages/Roster/FixtureRosterListPage/enums/fixtureRosterTableColumns.ts";
import { SeasonRosterTableColumns } from "~pages/Roster/SeasonRosterListPage/enums/seasonRosterTableColumns.ts";
import type { DataTableColumnGroupDefinition } from "~types/dataTableColumnGroupDefinition.ts";
import type { UiConfiguration } from "~types/uiConfiguration.ts";
import { defaultUiConfig } from "./defaultsUi";

const rosterPersonDetailColumns: DataTableColumnGroupDefinition["columns"] = [
  { key: RosterTableColumns.PersonNameFullLatin },
  { key: RosterTableColumns.PersonAdditionalDetailsHeight },
  { key: RosterTableColumns.PersonAdditionalDetailsWeight },
  { key: RosterTableColumns.PersonAdditionalDetailsHeightImperial },
  { key: RosterTableColumns.PersonAdditionalDetailsWeightImperial },
  { key: RosterTableColumns.PersonAdditionalDetailsRepresentation },
  { key: RosterTableColumns.PersonAdditionalDetailsJuniorAssociationLeague },
  { key: RosterTableColumns.PersonAdditionalDetailsHomeTown },
  { key: RosterTableColumns.PersonAdditionalDetailsCollege },
  { key: RosterTableColumns.PersonAdditionalDetailsCollegeClass },
  { key: RosterTableColumns.PersonAdditionalDetailsSchool },
  { key: RosterTableColumns.PersonAdditionalDetailsSchoolClass },
  { key: RosterTableColumns.Dob },
  { key: RosterTableColumns.PersonGender },
  { key: RosterTableColumns.PersonNationality },
  { key: RosterTableColumns.PersonRepresenting },
  { key: RosterTableColumns.PersonStatus },
];

const seasonRosterTableColumnsArray: Array<DataTableColumnGroupDefinition> = [
  {
    columnChooserTitleIntlKey: "roster.table.column.chooser.title.details",
    columns: [
      { key: RosterTableColumns.Bib, defaultInColumnChooser: true },
      { key: RosterTableColumns.NameFullLocal, defaultInColumnChooser: true },
      { key: RosterTableColumns.PersonId, defaultInColumnChooser: true },
      { key: RosterTableColumns.PersonExternalId, defaultInColumnChooser: true },
      { key: RosterTableColumns.ExternalId, defaultInColumnChooser: true },
      { key: RosterTableColumns.Position, defaultInColumnChooser: true },
      { key: RosterTableColumns.IsCaptain, defaultInColumnChooser: true },
      { key: SeasonRosterTableColumns.Status, defaultInColumnChooser: true },
      { key: RosterTableColumns.Caps, defaultInColumnChooser: true },
      ...rosterPersonDetailColumns,
    ],
  },
];

const fixtureRosterTableColumnsArray: Array<DataTableColumnGroupDefinition> = [
  {
    columnChooserTitleIntlKey: "roster.table.column.chooser.title.details",
    columns: [
      { key: RosterTableColumns.Bib, defaultInColumnChooser: true },
      { key: RosterTableColumns.NameFullLocal, defaultInColumnChooser: true },
      { key: RosterTableColumns.PersonId, defaultInColumnChooser: true },
      { key: RosterTableColumns.PersonExternalId, defaultInColumnChooser: true },
      { key: RosterTableColumns.ExternalId, defaultInColumnChooser: true },
      { key: RosterTableColumns.Position, defaultInColumnChooser: true },
      { key: FixtureRosterTableColumns.Starter, defaultInColumnChooser: true },
      { key: RosterTableColumns.IsCaptain, defaultInColumnChooser: true },
      { key: RosterTableColumns.Caps, defaultInColumnChooser: true },
      ...rosterPersonDetailColumns,
    ],
  },
];

export const footballUiConfig: UiConfiguration = {
  ...defaultUiConfig,
  pages: {
    ...defaultUiConfig.pages,
    seasonRoster: {
      listPage: {
        columnsConfig: seasonRosterTableColumnsArray,
        importConfig: {
          titleIntlKey: "import.modal.title.seasonRoster",
          descriptionIntlKey: "import.modal.text.seasonRoster",
        },
      },
      capsEnabled: true,
    },
    fixtureRoster: {
      listPage: {
        columnsConfig: fixtureRosterTableColumnsArray,
      },
      capsEnabled: true,
    },
  },
};
